import { Injectable } from '@angular/core';
import { SimpleConfigBaseFilter } from 'gung-list';
import { InvoiceStatistic } from '../../types';

@Injectable({
  providedIn: 'root'
})
export class OurReferenceFilterService extends SimpleConfigBaseFilter<InvoiceStatistic> {
  constructor() {
    super();
  }

  getName(): string {
    return 'OUR_REFERENCE';
  }
  getOptionIds(item: InvoiceStatistic): string[] {
    return [item.invoiceOurReference];
  }
  getOptionName(key: string): string {
    return key;
  }
}
